<div class="u-text-center">
  <h1 style="text-align: center;">{{data.title}}</h1>
  <div style="text-align: center;">
    <p>{{data.message}}</p>        
    <button nxButton="primary small" class="my-search-button" type="button" (click)="toggleTechnicalError()">
      Expandieren
    </button>
  </div>
</div>

<div *ngIf="showTechnicalError">
  <p>{{data.details}}</p>
  <p *ngIf="data.debugId">KorrelationId: {{data.debugId}}</p>
</div>
